import Awards from './Main'

const route = {
  path: '/awards',
  name: 'awards',
  meta: {
    title: 'Awards - A D M A N 2 0 1 9'
  },
  component: Awards
}

export default route
